// Centralized links/contacts for Rimfluences.
export const LINKS = {
  whatsapp:
    "https://wa.me/3519162751?text=Ciao%20Rimfluences%2C%20vorrei%20info%20sui%20vostri%20servizi",
  // Booking now goes to WhatsApp as the unique CTA
  bookCall: "https://wa.me/3519162751?text=Ciao%20Rimfluences%2C%20vorrei%20prenotare%20una%20call",
  instagram:
    "https://www.instagram.com/rimfluences?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
  tiktok: "https://tiktok.com/@rimfluences",
  facebook: "https://facebook.com/rimfluences",
  logo: "https://customer-assets.emergentagent.com/job_c7419280-cec7-4465-b846-41e2824d5e60/artifacts/0brhqgmb_521130487_17971534925918834_327898128768372886_n.jpg",
};

export const NAV = [
  { href: "#metodo", label: "Metodo" },
  { href: "#servizi", label: "Servizi" },
  { href: "#casi-studio", label: "Casi Studio" },
  { href: "#pacchetti", label: "Percorsi" },
  { href: "#contatti", label: "Contatti" },
];
